// in src/App.js
import React from 'react';
import { fetchUtils, Admin, Resource } from 'react-admin';
import simpleRestProvider from './rest/restClient';
import addUploadFeature from './rest/addUploadFeature'
import authProvider from './authProvider'
import createHistory from 'history/createBrowserHistory';
import Config from './config'
import { MessageCreate, MessageEdit, MessageList } from "./messages/Messages";
// Custom Theme
import CustomTheme from './CustomTheme'
import { ConfigCreate, ConfigEdit, ConfigList } from "./configs/Configs";
import {PornList, PornEdit, PornCreate} from "./porns/Porns";
import { ScreenCreate, ScreenEdit, ScreenList } from "./screens/Screens";
import { FaqCreate, FaqEdit, FaqList } from "./faqs/FAQs";
import { MealCreate, MealEdit, MealList } from "./meals/Meals";
import { BlockerCreate, BlockerEdit, BlockerList } from "./blockers/Blockers";
import { MCategoryCreate, MCategoryEdit, MCategoryList } from "./music_categories/M_Categories";
import { AudioCreate, AudioEdit, AudioList } from "./audio/Audio";

const history = createHistory();

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  // add your own headers here
  const token = localStorage.getItem('token');
  options.headers.set('Authorization', `${token}`);
  return fetchUtils.fetchJson(url, options);
}
const dataProvider = simpleRestProvider(Config.API, httpClient);
const uploadCapableDataProvider = addUploadFeature(dataProvider);

const App = () => (
  <Admin
    title="KidSafe Admin"
    history={history}
    dataProvider={uploadCapableDataProvider}
    authProvider={authProvider}
    theme={CustomTheme}
  >
    <Resource
      name="quick-messages"
      options={{ label: 'Quick Message' }}
      list={MessageList}
      edit={MessageEdit}
      create={MessageCreate}
    />

    <Resource
      name="porns"
      options={{ label: 'Porn Blocked' }}
      list={PornList}
      edit={PornEdit}
      create={PornCreate}
    />

    <Resource
      name="configs"
      options={{ label: 'Configs' }}
      list={ConfigList}
      edit={ConfigEdit}
      create={ConfigCreate}
    />

    <Resource
      name="screens"
      options={{ label: 'Screens' }}
      list={ScreenList}
      edit={ScreenEdit}
      create={ScreenCreate}
    />

    <Resource
      name="faqs"
      options={{ label: 'Faqs' }}
      list={FaqList}
      edit={FaqEdit}
      create={FaqCreate}
    />

    <Resource
      name="blockers"
      options={{ label: 'Blockers' }}
      list={BlockerList}
      edit={BlockerEdit}
      create={BlockerCreate}
    />

    <Resource
      name="meals"
      options={{ label: 'Meals' }}
      list={MealList}
      edit={MealEdit}
      create={MealCreate}
    />

    <Resource
      name="music-categories"
      options={{ label: 'Music Categories' }}
      list={MCategoryList}
      edit={MCategoryEdit}
      create={MCategoryCreate}
    />

    <Resource
      name="audio"
      options={{ label: 'Audio' }}
      list={AudioList}
      edit={AudioEdit}
      create={AudioCreate}
    />
  </Admin>
);

export default App;